export const ArrowLeftCategoriesIcon = () => {
  return (
    <svg
      width="9"
      height="8"
      data-testid="arrow-left-icon"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.97586 7.97587L4.74291 7.21735L2.07956 4.554H8.7699V3.44605H2.07956L4.74291 0.786954L3.97586 0.0241699L1.14441e-05 4.00002L3.97586 7.97587Z"
        fill="black"
      />
    </svg>
  );
};
